import type { VideoMetadata } from "./validation";

export type WidgetState =
  | { kind: "initial" }
  | { kind: "validating"; file: File }
  | {
      kind: "selected";
      file: File;
      previewUrl: string;
      meta: VideoMetadata;
    }
  | { kind: "authenticating"; file: File }
  | { kind: "creatingProject"; file: File }
  | { kind: "uploading"; file: File; progress: number; projectId: string }
  | { kind: "processing"; projectId: string; progress: number }
  | { kind: "previewReady"; projectId: string }
  | { kind: "error"; message: string; clearSessionOnRetry?: boolean };

export type Listener = (state: WidgetState) => void;

export class Store {
  private state: WidgetState = { kind: "initial" };
  private listeners: Set<Listener> = new Set();

  get(): WidgetState {
    return this.state;
  }

  set(next: WidgetState) {
    this.state = next;
    for (const l of this.listeners) l(next);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }
}
